import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiLinkedin,FiMail}=FiIcons;

const Hero=()=> {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative bg-gradient-to-br from-orange-50 to-blue-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{opacity: 0,x: -50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8}}
            className="space-y-8"
          >
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.2,duration: 0.8}}
            >
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
                Increasing market share, driving new product development,<span className="text-orange-600 block">and expanding client pipeline</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed mb-8 max-w-2xl">
                Sports industry consultancy with extensive experience in business development, marketing strategy, and revenue growth. Specializing in sales and business development for sports teams, sports events and sports media.
              </p>
            </motion.div>

            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.4,duration: 0.8}}
              className="flex flex-col sm:flex-row gap-4"
            >
              <motion.button
                whileHover={{scale: 1.05,boxShadow: "0 10px 25px -5px rgba(234,88,12,0.3)"}}
                whileTap={{scale: 0.95}}
                className="bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold text-lg flex items-center justify-center gap-2 hover:bg-orange-700 transition-all duration-300 shadow-lg"
              >
                Schedule Consultation
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </motion.button>
              <motion.button
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
                className="border-2 border-orange-600 text-orange-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-orange-50 transition-all duration-300"
              >
                Learn More
              </motion.button>
            </motion.div>

            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.6,duration: 0.8}}
              className="flex items-center gap-6 pt-8"
            >
              <div className="flex items-center gap-4">
                <motion.a
                  href="https://www.linkedin.com/in/leighalanklein/"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{scale: 1.1,y: -2}}
                  className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center hover:bg-blue-700 transition-all duration-300 shadow-lg"
                >
                  <SafeIcon icon={FiLinkedin} className="w-6 h-6" />
                </motion.a>
                <motion.a
                  href="mailto:leigh@kleinsportsconsulting.com"
                  whileHover={{scale: 1.1,y: -2}}
                  className="w-12 h-12 bg-gray-100 text-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-all duration-300 shadow-lg"
                >
                  <SafeIcon icon={FiMail} className="w-6 h-6" />
                </motion.a>
              </div>
              <div className="text-sm text-gray-500">
                <p className="font-semibold text-gray-700">Leigh Klein</p>
                <p>Sports Industry Consultancy & Media Host</p>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,x: 50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8,delay: 0.3}}
            className="relative"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-400/20 to-blue-400/20 rounded-3xl blur-3xl transform rotate-6"></div>
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759003455242-dbd20b95-0929-418b-9479-c72a27968e0f.jpg"
                alt="Leigh Klein - Sports Industry Consultancy"
                className="relative rounded-3xl shadow-2xl border border-white/20 transform -rotate-2 hover:rotate-0 transition-transform duration-500 w-full h-96 object-cover"
              />
            </div>

            {/* Floating stats */}
            <motion.div
              initial={{opacity: 0,scale: 0.8}}
              animate={{opacity: 1,scale: 1}}
              transition={{delay: 1,duration: 0.6}}
              className="absolute -top-8 -left-8 bg-white rounded-2xl shadow-xl p-6 border border-gray-100"
            >
              <div className="text-3xl font-bold text-orange-600">25+</div>
              <div className="text-sm text-gray-600">Years Experience</div>
            </motion.div>

            <motion.div
              initial={{opacity: 0,scale: 0.8}}
              animate={{opacity: 1,scale: 1}}
              transition={{delay: 1.2,duration: 0.6}}
              className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-xl p-6 border border-gray-100"
            >
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759003918677-IMG_0242.JPG"
                alt="That Bracket Show"
                className="w-20 h-16 object-cover rounded-lg"
              />
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-orange-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
      </div>
    </section>
  );
};

export default Hero;